import { render, staticRenderFns } from "./px-questionary-placeholder.vue?vue&type=template&id=f1530c2a&scoped=true&"
import script from "./px-questionary-placeholder.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary-placeholder.vue?vue&type=style&index=0&id=f1530c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1530c2a",
  null
  
)

export default component.exports